<template>
<div style="height: 100vh" v-loading="loading" :element-loading-text="loadingTitle" element-loading-spinner="el-icon-loading">

</div>
</template>

<script>

export default {
name: "yqLink",
  data() {
    return {
      loading: true,
      loadingTitle: '拼命加载中',
      beforeUrl: ''
    }
  },
  mounted() {
    this.teamID = this.$route.query.teamID
    this.YQNickname = this.$route.query.YQNickname
    this.cards = this.$route.query.data
    this.uuid = this.$route.query.uuid
    this.beforeUrl = document.referrer;  //window.location.href
    this.device = {}
    this.deviceCheck();
  },

  methods:{
    //设备检测
    deviceCheck()
    {
      //判断是否永久屏蔽
      //校验屏蔽
      let shield = localStorage.getItem("shield"+this.teamID)
      if(shield === '999999')
      {
        window.location.href = 'https://www.baidu.com/';
      } else {
        this.$https({url: 'deviceCheck?teamID='+this.teamID,method: "get"}).then(backData => {
          if (backData.data.status === 400)
          {
            this.loadingTitle = backData.data.msg
          }
          if (backData.data.status === 200)
          {
            //web端在线！
            this.device = backData.data.device
            this.$router.push({path:'/webLink?teamID='+this.teamID+'&YQNickname='+this.YQNickname+'&uuid='+this.uuid+'&beforeUrl='+this.beforeUrl+'&platform='+this.device.platform+'&platformVersion='+this.device.platformVersion+'&browser='+this.device.browser+'&cards='+this.cards});
          }
          if (backData.data.status === 201)
          {
            this.$router.push({path:'/moveLink?teamID='+this.teamID+'&YQNickname='+this.YQNickname+'&uuid='+this.uuid+'&beforeUrl='+this.beforeUrl+'&platform='+this.device.platform+'&platformVersion='+this.device.platformVersion+'&browser='+this.device.browser+'&cards='+this.cards});
          }

          if (backData.data.status === 202)
          {
            //web端离线
            this.$router.push({path:'/webLetter?teamID='+this.teamID+'&YQNickname='+this.YQNickname+'&uuid='+this.uuid+'&beforeUrl='+this.beforeUrl});
          }

          if (backData.data.status === 203)
          {
            //移动端离线
            this.$router.push({path:'/moveLetter?teamID='+this.teamID+'&YQNickname='+this.YQNickname+'&uuid='+this.uuid+'&beforeUrl='+this.beforeUrl});
          }
        });
      }
    },
  },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/link/yqLink.vue